module.exports = __webpack_public_path__ + "media/images/athletes/122-6ca3d972f38bb90eda590d40d75e04b1.png";